<template>
  <div :class="s.enquete">
    <div :class="s.header">
      <img src="/img/pages/enquete/header.png" alt="">
    </div>
    <div :class="s.campaign_section">
      <div :class="s.campaign_main">
        <img :class="s.campaign_mainCopy" src="/img/pages/choikulove/specialcampaign/campaign-copy.svg" alt="">
        <img :class="s.campaign_intro" src="/img/pages/choikulove/specialcampaign/campaign-intro.svg" alt="">
        <img :class="s.campaign_yellowKumo" src="/img/pages/choikulove/specialcampaign/yellow-kumo.svg" alt="">
        <div :class="s.campaign_text">
          <p :class="s.campaign_text_wrap">
            <span :class="s.campaign_text_pinkBorder">アンケート回答</span>
            <span> + </span>
            <span :class="s.campaign_text_pinkBorder">公式Xフォロー</span>
            <span :class="s.campaign_text_nowrap">
              <a :class="s.campaign_x_link" href="https://x.com/seeboncho" target="_blank">
              <span :class="s.campaign_text_pinkBorder">@seeboncho</span>
              </a>
              <span>だけ！</span>
            </span>
          </p>
          <!-- <p>
            <span>さらに、</span>
            <span :class="s.campaign_text_yellowMarker">動画を視聴して感想を書けば</span>
          </p>
          <p>
            <span>プレゼントの</span>
            <span :class="s.campaign_text_yellowMarker">当選確率がUP!!</span>
          </p> -->
        </div>
      </div>
    </div>
    <!-- グッズ紹介 -->
    <div :class="s.campaign_award_wrap">
      <div :class="s.campaign_award">
        <div :class="s.campaign_award_item">
          <img :class="s.campaign_award_item_main"
          src="/img/pages/choikulove/specialcampaign/a-shou.png" alt="">
          <img :class="s.campaign_award_item_hukidashi" src="/img/pages/choikulove/specialcampaign/a-shou-hukidashi.svg" alt="">
        </div>
        <div :class="s.campaign_award_item">
          <img :class="s.campaign_award_item_main"
          src="/img/pages/choikulove/specialcampaign/b-shou.png" alt="">
          <img :class="s.campaign_award_item_hukidashi" src="/img/pages/choikulove/specialcampaign/b-shou-hukidashi.svg" alt="">
        </div>
        <div :class="s.campaign_award_item">
          <img :class="s.campaign_award_item_main"
          src="/img/pages/choikulove/specialcampaign/c-shou.png" alt="">
          <img :class="s.campaign_award_item_hukidashi" src="/img/pages/choikulove/specialcampaign/c-shou-hukidashi.svg" alt="">
        </div>
      </div>
    </div>
    <div :class="s.movie_section">
      <img :class="s.movie_header" src="/img/pages/enquete/special-movie-title.svg" alt="">
      <div :class="s.movie_copy_wrap">
        <div :class="s.movie_copy">
          <span :class="s.movie_copy_span">動画を視聴すれば</span>
          <span :class="s.movie_copy_span">当選確率2倍！</span>
        </div>
      </div>
      <div :class="s.movie_content_wrap">
        <div :class="s.movie_content">
          <div :class="s.movie_wrap">
            <div :class="s.movie" v-html="videos[0].iframe"/>
            <img :class="s.movie_frame" src="/img/effects/movie_frame.svg" alt="">
            <div :class="s.movie_title_wrap">
              <div :class="s.movie_title">
                ちょいくらぶ #1
              </div>
              <div :class="s.movie_title_back">
              </div>
            </div>
          </div>
        </div>
        <div :class="s.movie_content">
          <div :class="s.movie_wrap">
            <div :class="s.movie" v-html="videos[1].iframe"/>
            <img :class="s.movie_frame" src="/img/effects/movie_frame.svg" alt="">
            <div :class="s.movie_title_wrap">
              <div :class="s.movie_title">
                ちょいくらぶ #2
              </div>
              <div :class="s.movie_title_back">
              </div>
            </div>
          </div>
        </div>
        <div :class="s.movie_content">
          <div :class="s.movie_wrap">
            <div :class="s.movie" v-html="videos[2].iframe"/>
            <img :class="s.movie_frame" src="/img/effects/movie_frame.svg" alt="">
            <div :class="s.movie_title_wrap">
              <div :class="s.movie_title">
                ちょいくらぶ #3
              </div>
              <div :class="s.movie_title_back">
              </div>
            </div>
          </div>
        </div>
        <div :class="s.movie_content">
          <div :class="s.movie_wrap">
            <div :class="s.movie" v-html="videos[3].iframe"/>
            <img :class="s.movie_frame" src="/img/effects/movie_frame.svg" alt="">
            <div :class="s.movie_title_wrap">
              <div :class="s.movie_title">
                限定グッズ紹介！
              </div>
              <div :class="s.movie_title_back">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="s.wrapper">
      <img :class="[s.wrapper_bg, s.left]" src="/img/pages/enquete/bg-container-left.png" alt="">
      <img :class="[s.wrapper_bg, s.right]" src="/img/pages/enquete/bg-container-right.png" alt="">
      <div ref="EnqueteContainer" :class="s.container">
        <!-- アンケートフォームセクション -->
        <picture>
          <source media="(max-width: 767px)" srcset="/img/pages/enquete/enquete-start-title-sp.svg">
          <img :class="s.form_header" src="/img/pages/enquete/enquete-start-title.svg" alt="">
        </picture>
        <section :class="s.form_section">
          <form @submit.prevent="submitForm" :class="s.form">
            <div :class="s.form_group">
              <!-- Q1（旧Q4/旧Q3）: 推しキャラクター -->
              <div :class="s.question_box_wrap">
                <div :class="s.question_box">
                  <img src="/img/pages/enquete/q1.svg" alt="1" :class="s.icon_q">
                  <div :class="s.field">
                    <label :class="s.label">
                      <span :class="s.bar">
                        ちょいくキャラクターの中で、
                        <br>
                        あなたの「推し」キャラクターはどれですか？
                      </span>
                    </label>
                    <CharacterButtons
                      v-model="formData.questions.q4"
                      entry-id="entry.1258548229"
                    />
                  </div>
                </div>
              </div>

              <!-- Q2（旧Q3/旧Q1）: 100万円の使い道 -->
              <div :class="s.question_box_wrap">
                <div :class="s.question_box">
                  <img src="/img/pages/enquete/q2.svg" alt="2" :class="s.icon_q">
                  <div :class="s.field">
                    <label :class="s.label">
                      <span :class="s.bar">100 万円もらったら何に使いますか？</span>
                    </label>
                    <SingleSelectButtons
                      v-model="formData.questions.q3"
                      :options="q3Options"
                      :has-other-option="true"
                      entry-id="entry.1370061467"
                    />
                  </div>
                </div>
              </div>

              <!-- Q3（旧2）: お金の管理 -->
              <div :class="s.question_box_wrap">
                <div :class="[ s.question_box ]">
                  <img src="/img/pages/enquete/q3.svg" alt="3" :class="s.icon_q">
                  <div :class="s.field">
                    <label :class="s.label">
                      <span :class="s.bar">お年玉やお小遣いなどのお金の管理方法について教えてください。</span>
                    </label>
                    <SingleSelectButtons
                      v-model="formData.moneyManagement"
                      :options="moneyManagementOptions"
                      entry-id="entry.1297179791"
                    />
                  </div>
                </div>
              </div>

              <!-- Q4（旧Q5/旧Q4）: 視聴動画 -->
              <div :class="s.question_box_wrap">
                <div :class="s.question_box">
                  <img src="/img/pages/enquete/q4.svg" alt="4" :class="s.icon_q">
                  <div :class="s.field">
                    <label :class="s.label">
                      <span :class="s.bar">
                        視聴した動画を教えてください。
                      </span>
                      （複数選択可）（任意）
                    </label>
                    <MultiSelectButtons
                      v-model="formData.questions.q5"
                      :options="q5Options"
                      entry-id="entry.1053376328"
                    />
                  </div>
                </div>
              </div>

              <!-- Q5（旧Q6/旧Q5）: 視聴きっかけ -->
              <div :class="s.question_box_wrap">
                <div :class="s.question_box">
                  <img src="/img/pages/enquete/q5.svg" alt="5" :class="s.icon_q">
                  <div :class="s.field">
                    <label :class="s.label">
                      <span :class="s.bar">
                        動画を視聴したきっかけを教えてください。
                      </span>
                      （任意）
                    </label>
                    <MultiSelectButtons
                      v-model="formData.questions.q6"
                      :options="q6Options"
                      :has-other-option="true"
                      entry-id="entry.1643573443"
                    />
                  </div>
                </div>
              </div>

              <!-- Q6（旧Q7/旧Q6）: お金への意識変化 -->
              <div :class="s.question_box_wrap">
                <div :class="s.question_box">
                  <img src="/img/pages/enquete/q6.svg" alt="6" :class="s.icon_q">
                  <div :class="s.field">
                    <label :class="s.label">
                      <span :class="s.bar">
                        動画視聴後、お金の使い道に対する意識は変化しましたか？<br>お金を増やすことへの関心は変化しましたか？
                      </span>
                      （任意）
                    </label>
                    <SingleSelectButtons
                      v-model="formData.questions.q7"
                      :options="q7Options"
                      entry-id="entry.471446235"
                    />
                  </div>
                </div>
              </div>

              <!-- Q7（旧Q8/旧Q7）: 実践したいこと -->
              <div :class="s.question_box_wrap">
                <div :class="s.question_box">
                  <img src="/img/pages/enquete/q7.svg" alt="7" :class="s.icon_q">
                  <div :class="s.field">
                    <label :class="s.label">
                      <span :class="s.bar">
                        動画を視聴して、今後実践してみたいことはありますか？
                      </span>
                      （複数選択可）（任意）
                    </label>
                    <MultiSelectButtons
                      v-model="formData.questions.q8"
                      :options="q8Options"
                      :has-other-option="true"
                      entry-id="entry.2012701841"
                    />
                  </div>
                </div>
              </div>

              <!-- Q8（旧1）: プロフィール -->
              <div :class="s.question_box_wrap">
                <div :class="[ s.question_box ]">
                  <img src="/img/pages/enquete/q8.svg" alt="8" :class="s.icon_q">
                  <div :class="s.profile_row_wrap">
                    <div :class="s.profile_row">
                      <div :class="s.profile_item">
                        <label :class="[s.label, s.profile]">年齢</label>
                        <input
                          v-model="formData.profile.age"
                          type="number"
                          min=0
                          max=100
                          :class="[s.select_input, { [s.error]: validationErrors.age }]"
                          name="entry.2106124052"
                          placeholder="例: 15"
                          aria-required="true"
                        />
                        <span
                          v-if="validationErrors.age"
                          :class="s.error_message"
                          role="alert"
                          aria-live="polite"
                        >
                          {{ validationErrors.age }}
                        </span>
                      </div>

                      <div :class="s.profile_item">
                        <label :class="[s.label, s.profile]">性別</label>
                        <select
                          v-model="formData.profile.gender"
                          :class="[s.select_input, { [s.error]: validationErrors.gender }]"
                          name="entry.1407262755"
                          aria-required="true"
                        >
                          <option value="男性">男性</option>
                          <option value="女性">女性</option>
                          <option value="回答しない">回答しない</option>
                        </select>
                        <span
                          v-if="validationErrors.gender"
                          :class="s.error_message"
                          role="alert"
                          aria-live="polite"
                        >
                          {{ validationErrors.gender }}
                        </span>
                      </div>
                    </div>
                    <div :class="s.profile_row">
                      <div :class="s.profile_item">
                        <label :class="[s.label, s.profile]">連絡先</label>
                        <input
                          v-model="formData.profile.contact"
                          type="text"
                          :class="s.text_input"
                          placeholder="例: メールアドレス、X、インスタのアカウント名"
                          name="entry.1386795470"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Q9（旧Q9/旧Q8）: Tシャツサイズ -->
              <div :class="s.question_box_wrap">
                <div :class="s.question_box">
                  <img src="/img/pages/enquete/q9.svg" alt="9" :class="s.icon_q">
                  <div :class="s.field">
                    <label :class="s.label">
                      <span :class="s.bar">
                        Tシャツが当選した場合どちらのサイズをご希望されますか？
                      </span>
                      （複数選択可）（任意）
                    </label>
                    <MultiSelectButtons
                      v-model="formData.questions.q9"
                      :options="q9Options"
                      entry-id="entry.995902711"
                    />
                  <p :class="s.note">
                  応募状況によってご希望に添えない場合もございますので予めご了承ください。
                  <br>
  （本編内では面髙さんがXL、石川さんがL、谷田さんがMを着用されています）</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 送信ボタン -->
            <div :class="s.submit_wrapper">
              <img src="/img/pages/enquete/bg_submit_wrapper.svg" :class="s.submit_wrapper_bg" alt="">
              <div :class="s.submit_section">
                <img src="/img/pages/enquete/finish.png" alt="回答する">
                <button
                  type="submit"
                  :class="s.submit_btn"
                  :disabled="isSubmitting"
                >
                  <img src="/img/pages/enquete/submit.svg" alt="回答する">
                </button>
              </div>
            </div>
          </form>
        </section>
      </div>
    </div>
    <!-- 固定アンケートスタートボタン -->
    <div :class="[s.fixed_start_button, { [s.hidden]: !showStartButton }]">
      <div :class="s.questionary_start_content">
        <button @click="scrollToForm" :class="s.questionary_start_btn">
          <dot-bg-btn :is-enquete="true">アンケートスタート<span :class="s.questionary_italic">!!</span></dot-bg-btn>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import SingleSelectButtons from '@/components/parts/SingleSelectButtons.vue';
import MultiSelectButtons from '@/components/parts/MultiSelectButtons.vue';
import CharacterButtons from '@/components/parts/CharacterButtons.vue';
import { DotBgBtn } from '@/components/parts';
import {
  requiredIfQ3Other,
  requiredIfQ6Other,
  requiredIfQ8Other,
} from '@/validators/enqueteValidators';
import { VALIDATION_MESSAGES } from '@/validators/validationMessages';
import { getFieldSelector } from '@/utils/formFieldMapping';
import googleFormSubmitter from '@/utils/googleFormSubmitter';

export default {
  name: 'Enquete',
  components: {
    SingleSelectButtons,
    MultiSelectButtons,
    CharacterButtons,
    DotBgBtn,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      validationErrors: {},
      saveToLocalStorageTimer: null,
      showStartButton: true,
      formObserver: null,
      moneyManagementOptions: [
        { value: 'すぐに使い切る', label: 'すぐに使い切る' },
        { value: '少しだけ貯金している', label: '少しだけ貯金している' },
        { value: 'しっかり貯金している', label: 'しっかり貯金している' },
      ],
      // Q3（旧Q1）: 100万円の使い道
      q3Options: [
        { value: '貯金する', label: '貯金する' },
        { value: '経験に使う', label: '経験に使う' },
        { value: '欲しいものを買う', label: '欲しいものを買う' },
        { value: '家族や身近な人のために使う', label: '家族や身近な人のために使う' },
        { value: '起業や副業の資金にする', label: '起業や副業の資金にする' },
        { value: '投資してお金を増やす', label: '投資してお金を増やす' },
      ],
      // Q5（旧Q4）: 視聴動画
      q5Options: [
        {
          value: 'ちょいくらぶ #1',
          label: 'ちょいくらぶ #1',
          descriptions: [
            '① 最近考えが変わったこと、考えていることは？？',
            '② どんな高校生だった？',
            '③ 高校時代の思い出',
          ],
        },
        {
          value: 'ちょいくらぶ #2',
          label: 'ちょいくらぶ #2',
          descriptions: [
            '④ お金の使い道を紹介してください',
            '⑤ お金についての考え方は？',
            '⑥ １００万円もらったらどうする？？',
            '⑦ ちょいくせ未来予報発表！',
          ],
        },
        {
          value: 'ちょいくらぶ #3',
          label: 'ちょいくらぶ #3',
          descriptions: [
            '⑧高校生のうちにやっておいた方がいいこと　トップ３',
          ],
        },
      ],
      // Q6（旧Q5）: 視聴きっかけ
      q6Options: [
        { value: 'お金の話に興味があったから', label: 'お金の話に興味があったから' },
        { value: '出演者に興味があったから', label: '出演者に興味があったから' },
        { value: 'ちょいくプロジェクトに興味があったから', label: 'ちょいくプロジェクトに興味があったから' },
        { value: 'キャラクターが可愛いかったから', label: 'キャラクターが可愛いかったから' },
        { value: '面白そうな動画だと思ったから', label: '面白そうな動画だと思ったから' },
        { value: 'プレゼント景品が欲しかったから', label: 'プレゼント景品が欲しかったから' },
      ],
      // Q7（旧Q6）: お金への意識変化
      q7Options: [
        { value: 'とても高くなった', label: 'とても高くなった' },
        { value: '少し高くなった', label: '少し高くなった' },
        { value: 'あまり変わらなかった', label: 'あまり変わらなかった' },
        { value: '全く変わらなかった', label: '全く変わらなかった' },
      ],
      // Q8（旧Q7）: 実践したいこと
      q8Options: [
        { value: '家計簿アプリでお金の管理をする', label: '家計簿アプリでお金の管理をする' },
        { value: '将来の選択肢を増やすために貯金する', label: '将来の選択肢を増やすために貯金する' },
        { value: '無駄遣いを減らす努力をする', label: '無駄遣いを減らす努力をする' },
        { value: '時間の使い方を意識して、計画的に行動する', label: '時間の使い方を意識して、計画的に行動する' },
        { value: '本やサイトでお金に関することを調べる', label: '本やサイトでお金に関することを調べる' },
        { value: '家族とお金の使い道について話す', label: '家族とお金の使い道について話す' },
        { value: '自分のやりたいことに繋がるよう沢山の経験をする', label: '自分のやりたいことに繋がるよう沢山の経験をする' },
        { value: '特にない', label: '特にない' },
      ],
      // Q9（旧Q8）: Tシャツサイズ
      q9Options: [
        { value: 'M', label: 'Mサイズ' },
        { value: 'L', label: 'Lサイズ' },
        { value: 'XL', label: 'XLサイズ' },
        { value: 'どのサイズでも良い', label: 'どのサイズでも良い' },
      ],
      videos: [
        {
          id: 1,
          thumbnail: '/img/thumbnails/choikulove-1.jpg',
          iframe: `
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/l2O8alOZHpM?si=wP7qsdp-JTW-zySk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          `,
        },
        {
          id: 2,
          thumbnail: '/img/thumbnails/choikulove-2.jpg',
          iframe: `
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/0SN9HTuaJjs?si=3XkrGokbzBwi1s7b" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          `,
        },
        {
          id: 3,
          thumbnail: '/img/thumbnails/choikulove-3.jpg',
          iframe: `
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/HzXqDltf-dc?si=QoZoHc9uznUpQdoL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          `,
        },
        {
          id: 4,
          thumbnail: '/img/thumbnails/choikulove-4.jpg',
          iframe: `
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/jO4V_LsrQSo?si=OiRiUAwKsFCzMoka" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          `,
        },
      ],
    };
  },
  computed: {
    formData: {
      get() {
        return this.$store.state.enquete.formData;
      },
      set(value) {
        this.$store.commit('enquete/setFormData', value);
      },
    },
    isSubmitting() {
      return this.$store.state.enquete.isSubmitting;
    },
    isSubmitted() {
      return this.$store.state.enquete.isSubmitted;
    },
  },
  watch: {
    'formData.profile': {
      handler() {
        this.debouncedSaveToLocalStorage();
      },
      deep: true,
    },
    'formData.moneyManagement': function () {
      this.debouncedSaveToLocalStorage();
    },
    'formData.questions': {
      handler() {
        this.debouncedSaveToLocalStorage();
      },
      deep: true,
    },
  },
  async created() {
    console.log('Enquete page loaded');

    // 開発環境でクエリパラメータに?reset=1がある場合はLocalStorageをクリア
    if (process.env.NODE_ENV !== 'production' && this.$route.query.reset === '1') {
      console.log('Clearing LocalStorage (development mode)');
      this.$store.dispatch('enquete/clearAll');
    }

    // 送信済みチェック
    const isSubmitted = await this.$store.dispatch('enquete/checkSubmissionStatus');
    if (isSubmitted) {
      // 送信済みの場合はサンクスページへリダイレクト
      console.log('Already submitted, redirecting to thanks page');
      this.$router.push('/enquete/thanks');
      return;
    }

    // LocalStorageからフォームデータを復元
    this.$store.dispatch('enquete/loadFromLocalStorage');
  },
  mounted() {
    // IntersectionObserverでフォーム開始位置の通過を検知
    this.setupFormObserver();
  },
  beforeUnmount() {
    // タイマーのクリーンアップ
    if (this.saveToLocalStorageTimer) {
      clearTimeout(this.saveToLocalStorageTimer);
      // ページ離脱時に最終保存を実行
      this.$store.dispatch('enquete/saveToLocalStorage');
    }
    // IntersectionObserverのクリーンアップ
    if (this.formObserver) {
      this.formObserver.disconnect();
      this.formObserver = null;
    }
  },
  validations() {
    return {
      formData: {
        profile: {
          age: { required },
          gender: { required },
        },
        moneyManagement: { required },
        questions: {
          q3: { required },
          q3Other: { requiredIfQ3Other },
          q4: { required },
          q6Other: { requiredIfQ6Other },
          q8Other: { requiredIfQ8Other },
        },
      },
    };
  },
  methods: {
    /**
     * デバウンス付きLocalStorage保存
     * 入力応答性を向上させるため、500msの遅延を設ける
     */
    debouncedSaveToLocalStorage() {
      if (this.saveToLocalStorageTimer) {
        clearTimeout(this.saveToLocalStorageTimer);
      }
      this.saveToLocalStorageTimer = setTimeout(() => {
        this.$store.dispatch('enquete/saveToLocalStorage');
      }, 500);
    },

    /**
     * フォームのバリデーションを実行
     * @returns {Object} { isValid: boolean, errors: Object }
     */
    validateForm() {
      this.v$.$touch();

      const errors = {};

      // プロフィール項目のエラー
      if (this.v$.formData.profile.age.$error) {
        errors.age = VALIDATION_MESSAGES.AGE_REQUIRED;
      }

      if (this.v$.formData.profile.gender.$error) {
        errors.gender = VALIDATION_MESSAGES.GENDER_REQUIRED;
      }

      // 設問2: お金の管理
      if (this.v$.formData.moneyManagement.$error) {
        errors.moneyManagement = VALIDATION_MESSAGES.MONEY_MANAGEMENT_REQUIRED;
      }

      // 質問3（旧Q1）: 100万円の使い道
      if (this.v$.formData.questions.q3.$error) {
        errors.q3 = VALIDATION_MESSAGES.Q1_REQUIRED;
      }

      // 「その他」が選択されているときのみエラーチェック
      if (this.v$.formData.questions.q3Other.$error && this.formData.questions.q3 === 'その他') {
        errors.q3Other = VALIDATION_MESSAGES.OTHER_TEXT_REQUIRED;
      }

      // 質問4（旧Q3）: 推しキャラクター
      if (this.v$.formData.questions.q4.$error) {
        errors.q4 = VALIDATION_MESSAGES.Q3_REQUIRED;
      }

      // 質問6（旧Q5）: 視聴きっかけの「その他」（複数選択・任意）
      if (this.v$.formData.questions.q6Other.$error
          && Array.isArray(this.formData.questions.q6)
          && this.formData.questions.q6.includes('その他')) {
        errors.q6Other = VALIDATION_MESSAGES.OTHER_TEXT_REQUIRED;
      }

      // 質問8（旧Q7）: 実践したいことの「その他」（複数選択・任意）
      if (this.v$.formData.questions.q8Other.$error
          && Array.isArray(this.formData.questions.q8)
          && this.formData.questions.q8.includes('その他')) {
        errors.q8Other = VALIDATION_MESSAGES.OTHER_TEXT_REQUIRED;
      }

      this.validationErrors = errors;

      return {
        isValid: Object.keys(errors).length === 0,
        errors,
      };
    },

    /**
     * エラーフィールドへスクロール
     * @param {string} fieldName - エラーフィールド名
     */
    scrollToError(fieldName) {
      this.$nextTick(() => {
        const selector = getFieldSelector(fieldName);

        if (selector) {
          const element = document.querySelector(selector);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // フォーカスを設定（input要素の場合のみ）
            if (element.tagName === 'INPUT') {
              element.focus();
            }
          }
        }
      });
    },

    /**
     * IntersectionObserverの設定
     * container要素が見えたらボタンを非表示にする
     */
    setupFormObserver() {
      this.$nextTick(() => {
        if (!this.$refs.EnqueteContainer) {
          return;
        }

        const options = {
          root: null, // ビューポートをルートとして使用
          rootMargin: '-50px 0px 0px 0px', // 上部100px手前で検知
          threshold: 0, // 要素が少しでも見えたら検知
        };

        this.formObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            // containerの上部が見えたらボタンを非表示
            // entry.isIntersectingがtrue = containerが見えている = ボタンを非表示
            this.showStartButton = !entry.isIntersecting;
          });
        }, options);

        this.formObserver.observe(this.$refs.EnqueteContainer);
      });
    },

    /**
     * アンケートセクションへスクロール
     */
    scrollToForm() {
      if (this.$refs.EnqueteContainer) {
        this.$refs.EnqueteContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },

    /**
     * フォーム送信処理
     */
    async submitForm() {
      // 送信中または送信済みの場合は処理しない
      if (this.isSubmitting || this.isSubmitted) {
        return;
      }

      // バリデーション実行
      const validation = this.validateForm();

      if (!validation.isValid) {
        console.log('Validation errors:', validation.errors);

        // 最初のエラーフィールドにスクロール
        const firstErrorField = Object.keys(validation.errors)[0];
        if (firstErrorField) {
          this.scrollToError(firstErrorField);
        }

        return;
      }

      // 送信処理開始
      this.$store.dispatch('enquete/startSubmission');

      try {
        console.log('Submitting form data to Google Form...');

        // Google Formに送信
        const result = await googleFormSubmitter.submitToGoogleForm(this.formData);

        if (result.success) {
          console.log('Form submission successful:', result);

          // 送信完了処理
          this.$store.dispatch('enquete/completeSubmission');

          // サンクスページへ遷移
          this.$router.push('/enquete/thanks');
        } else {
          throw new Error('送信に失敗しました');
        }
      } catch (error) {
        console.error('Form submission error:', error);
        this.$store.dispatch('enquete/failSubmission', error.message || 'フォームの送信に失敗しました。もう一度お試しください。');

        // エラーメッセージを表示
        alert(`送信エラー: ${error.message || 'フォームの送信に失敗しました。もう一度お試しください。'}`);
      }
    },
  },
};
</script>

<style lang="scss" module="s">
.enquete {
  width: 100%;
  min-height: 100vh;
  background-color: #ffec3f;
}

.header {
  position: relative;
}

.campaign_section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6vw;
  max-width: 1450px;
  margin: 0 auto;
  margin-top: calc(-100 / 1920 * 100%);
  margin-bottom: 50px;

  @include smView {
    margin-bottom: 0;
  }
}

.campaign_main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  position: relative;
  width: 75%;
  height: auto;
  z-index: 3;
  background-image: url('/img/pages/choikulove/specialcampaign/white-kumo1.svg');
  background-repeat: no-repeat;
  background-position: center;
  padding: 7% 7% 4%;
  background-size: contain;
  max-width: 1260px;

  @include smView {
    width: 95%;
    padding: 11% 11% 7%;
    gap: 14px;
    margin-bottom: 25px;
  }
}

.campaign_mainCopy {
  position: relative;
  width: 80%;
  z-index: 3;
  margin-top: -12%;

  @include mdView {
    margin-top: -10%;
  }

  @include smView {
    margin-top: -16%;
  }
}

.campaign_intro {
  position: relative;
  width: 85%;
  z-index: 3;

  @include smView {
    width: 100%;
  }
}

.campaign_yellowKumo {
  position: relative;
  width: 34%;
  height: auto;
  z-index: 3;

  @include smView {
    width: 37vw;
  }
}

.campaign_text {
  font-size: 26px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @include smView {
    font-size: 3vw;
  }
}

.campaign_text_pinkBorder {
  border-bottom: 9px solid var(--primary-pink);
  line-height: 1.4;

  @include smView {
    border-bottom: 3px solid var(--primary-pink);
  }
}

.campaign_text_nowrap {
  white-space: nowrap;
}

.campaign_x_link {
  text-decoration: none;
  white-space: nowrap;
}

.campaign_text_yellowMarker {
  background-color: var(--primary-yellow);
}


.movie_section {
  position: relative;
  padding: 0 100px;

  @include mdView {
    padding: 0 40px;
  }

  @include smView {
    padding: 0 20px;
  }

  @include xsView {
    padding: 0 20px;
  }
}

.movie_header {
  margin-bottom: 50px;
}

.movie_content_wrap {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 60px;
  margin-bottom: 50px;

  @include mdView {
    gap: 30px;
  }

  @include smView {
    gap: 10px;
  }
}

.movie_content {
  position: relative;
  z-index: 4;
  margin-bottom: 20px;
  width: calc((100% - 60px) / 2);

  @include mdView {
    margin-bottom: 10px;
  }

  @include smView {
    margin-top: 20px;
    width: calc((100% - 10px) / 2);
  }
}

.movie_wrap {
  position: relative;
  width: 100%;
  z-index: 4;
}

.movie_wrap_1 {
  width: calc((100% - 60px) / 2);

  @include smView {
    width: 100%;
    margin: 0;
  }
}

.movie {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 89%;
  height: 83%;
  transform: translate(-50.55%, -51%);
  margin: 0 auto;
}

.movie_frame {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 4;
  pointer-events: none;
}

.movie_title_wrap {
  position: absolute;
  z-index: 5;
  bottom: 0;
  translate: 0 35%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: fit-content;
  height: auto;
  transform: rotate(-5deg);
  transform-origin: center;
}

.movie_title {
  position: relative;
  z-index: 5;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.5;
  width: 100%;
  height: auto;
  background-color: var(--primary-green);
  border: 1px solid var(--primary-black);
  border-radius: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 30px;

  @include mdView {
    font-size: 18px;
    padding: 11px 28px;
  }
  @include smView {
    font-size: 12px;
    padding: 5px 14px;
  }
}

.movie_title_back {
  position: absolute;
  top: 7px;
  left: 7px;
  z-index: 4;
  width: 100%;
  height: 100%;
  background-color: var(--primary-pink);
  border: 1px solid var(--primary-black);
  border-radius: 50px;

  @include smView {
  }
}

.wrapper {
  position: relative;
}

.wrapper_bg {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 0;
  height: auto;

  &.left {
    left: calc(-500px + 15vw);
    width: 774px;
  }

  &.right {
    translate: 100px 130px;
    right: calc(-400px + 15vw);
    width: 700px;
  }

  @include mdView {
    display: none;
  }
}

.container {
  position: relative;
  max-width: 1380px;
  margin: 0 auto;
  padding: 40px 100px 500px;
}

.title {
  font-size: 32px;
  font-weight: 700;
  color: var(--primary-black);
  margin-bottom: 24px;
}

.description {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

.form_section {
  padding: 40px 0;
}

.form_header {
  margin-bottom: 25px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 96px;
}

.form_group {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.profile_row_wrap {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.profile_row {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.profile_item {
  display: flex;
  flex-direction: column;
}

.question_box_wrap {
  position: relative;
  width: 100%;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: #fff;
    border: 3px solid #000;
    border-radius: 43px;
    translate: 11px 13px;
    transition: all 0.2s ease;
    background: var(--primary-color, #4CAF50) url(/img/pages/choikulove/bg-dot.svg) repeat;
    background-size: 10px;
  }
}

.question_box {
  position: relative;
  z-index: 2;
  border: 3px solid #000;
  border-radius: 43px;
  background: #fff;
  padding: 60px;
}


.field {
  margin-bottom: 0;
}

.label {
  position: relative;
  display: block;
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 12px;
  text-align: center;
}

.bar {
  position: relative;
  display: block;
  width: fit-content;
  margin: auto;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 12px;
    margin-block: 5px;
    background-color: var(--primary-pink);
    border: 1.5px solid #000;
    border-radius: 7px;
  }
}

.icon_alphabet {
  position: absolute;
  left: 13px;
  top: 13px;
  display: block;
  width: 54px;
  height: auto;
  aspect-ratio: 1;
}

.icon_q {
  position: absolute;
  left: 40px;
  top: 35px;
  display: block;
  width: 115px;
  height: auto;
  aspect-ratio: 1;
}

.field_description {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.6;
}

.select_input {
  width: 150px;
  height: 75px;
  font-size: 20px;
  color: #000;
  font-weight: bold;
  background-color: #fff;
  border: 3px solid #000;
  transition: border-color 0.2s ease;
  cursor: pointer;
  appearance: none;
  text-align: center;

  &:focus {
    outline: none;
    border-color: var(--primary-color, #4CAF50);
    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
  }

  &.error {
    border-color: #ff5252;
    background-color: #fff5f5;
  }

  option[value=""][disabled] {
    color: #999;
  }
}

.text_input {
  width: 300px;
  height: 75px;
  font-size: 20px;
  line-height: 4;
  padding-left: 40px;
  color: #000;
  font-weight: bold;
  background-color: #fff;
  border: 3px solid #000;
  transition: border-color 0.2s ease;
  cursor: pointer;
  appearance: none;

  &:focus {
    outline: none;
    border-color: var(--primary-color, #4CAF50);
    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
  }

  &::placeholder {
    color: #999;
  }

  &.error {
    border-color: #ff5252;
    background-color: #fff5f5;
  }
}

.note {
  margin-top: 50px;
  font-size: 24px;
  line-height: 1.3;
  text-align: center;
}

.optional {
  color: #999;
  font-weight: 400;
  font-size: 14px;
  margin-left: 4px;
}

.error_message {
  display: block;
  margin-top: 6px;
  font-size: 14px;
  color: #ff5252;
  font-weight: 500;
}

.submit_wrapper {
  position: relative;
}

.submit_wrapper_bg {
  position: absolute;
  left: 50%;
  translate: -50% -5vw;
  width: min(1700px, 100vw);
  height: auto;
  z-index: 0;

  @include smView {
    width: 160vw;
    translate: -50% 15vw;
  }

  @include xsView {
    width: 180vw;
    translate: -50% 30vw;
  }
}

.submit_section {
  position: relative;
  z-index: 2;
  margin-inline: auto;
  padding-top: 32px;
  max-width: 400px;

  @include smView {
    width: 80%;
  }

  @include xsView {
    width: 80%;
  }
}

.submit_btn {
  position: relative;
  display: block;
  margin: -60px auto 0;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 70%;

  @include smView {
    margin-top: -40px;
  }

  &:hover:not(:disabled) {
  }

  &:active:not(:disabled) {
  }

  &:disabled {
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.6;
  }

  img {
    position: relative;
    z-index: 2;
  }

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    content: '';
    translate: 11px 13px;
    background-image: url('/img/pages/enquete/bg_submit.svg');
    transition: all .3s;
    background-repeat: no-repeat;

    @include smView {
    translate: 8px 9px;
    }
  }

  &:active::before {
    translate: 0 0;
  }
}

// タブレット対応
@include mdView {
  .header {
    width: 120vw;
    translate: -10vw 0;
  }

  .container {
    padding: 30px 40px 400px;
  }

  .question_box {
    padding: 40px 40px 45px 30px;
  }

  .profile_row {
    flex-wrap: wrap;
  }

  .description_section {
    margin-bottom: 40px;
    padding: 30px 16px;
  }

  .title {
    font-size: 28px;
    margin-bottom: 20px;
  }

  .description {
    font-size: 15px;
  }

  .form_section {
    padding: 30px 0;
  }

  .icon_q {
    left: 25px;
    top: 20px;
    width: 70px;
  }

  .label {
    font-size: 20px;
    padding-left: 70px;
    &.b {
      padding-left: 0;
    }

    &.profile {
      padding: 0;
    }
  }

  .text_input {
    font-size: 15px;
    padding: 10px 14px;
    height: 60px;
  }

  .select_input {
    font-size: 15px;
    padding: 10px 0;
    background-size: 18px;
    height: 60px;
    width: 120px;
  }

  .note {
    font-size: 16px;
  }
}

// スマートフォン対応
@include smView {
  .header {
    width: 140vw;
    translate: -20vw 0;
  }

  .container {
    padding: 24px 12px 500px;
  }

  .description_section {
    margin-bottom: 32px;
    padding: 24px 16px;
  }

  .title {
    font-size: 24px;
    margin-bottom: 16px;
  }

  .description {
    font-size: 14px;
    line-height: 1.7;
  }

  .question_box_wrap {
    &::before {
      border-radius: 30px;
      translate: 8px 9px;
      transition: all 0.2s ease;
      background: var(--primary-color, #4CAF50) url(/img/pages/choikulove/bg-dot.svg) repeat;
      background-size: 10px;
    }
  }

  .question_box {
    position: relative;
    z-index: 2;
    border: 3px solid #000;
    border-radius: 43px;
    background: #fff;
    padding: 60px;
  }

  .question_box {
    border-radius: 30px;
    padding: 20px 20px 20px 11px;
  }

  .profile_row {
  }

  .icon_q {
    left: 20px;
    top: 15px;
    width: 60px;
  }

  .label {
    font-size: 18px;
    padding-inline: 85px 20px;

    &.profile {
      font-size: 16px;
      padding: 0;
    }
  }

  .text_input {
    font-size: 14px;
    padding: 10px 12px;
  }

  .select_input {
    font-size: 14px;
    padding: 10px 0;
  }

  .submit_section {
    margin-top: 40px;
    padding-top: 24px;
  }

  .note {
    margin-top: 30px;
    padding-inline: 15px;
    text-align: left;
    font-size: 12px;
    line-height: 1.5;

    br {
      display: none;
    }
  }
}

// 小型スマートフォン対応
@include xsView {
  .enquete {
    //padding: 20px px 300px;
  }

  .description_section {
    margin-bottom: 24px;
    padding: 20px 12px;
  }

  .title {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .description {
    font-size: 13px;
  }

  .question_box {
    padding: 18px 15px 20px 10px;

    &:first-of-type {
      padding-top: 36px;
    }
  }

  .profile_row {
    flex-direction: row;
    width: 100%;
  }

  .profile_item {
    width: 100%;
  }

  .icon_alphabet {
    left: 10px;
    top: 10px;
    width: 43px;
  }

  .icon_q {
    left: 10px;
    top: 10px;
    width: 50px;
  }

  .label {
    padding-inline: 55px 10px;
    font-size: 16px;
  }

  .text_input {
    font-size: 13px;
    padding: 8px 10px;
    width: 80%;
    margin: auto;
  }

  .select_input {
    font-size: 13px;
    padding: 8px 10px;
    width: 80%;
    margin: auto;
  }

  .field_description {
    font-size: 12px;
  }
}


// グッズ紹介
.campaign_award_wrap {
  position: relative;
  z-index: 4;
  width: 80%;
  margin: 0 auto 100px auto;
  background-image: url('/img/pages/choikulove/specialcampaign/award-bg.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 95% 95%;

  @include smView {
    margin-bottom: 0;
    width: 100%;
  }
}

.campaign_award {
  position: relative;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 27px;
  width: min(calc(100% - 60px * 2),1450px);
  margin: 0 auto;
  padding-bottom: 10px;

  @include smView {
    gap: 3px;
    padding-inline: 5px 15px;
    width: 100%;
    padding-bottom: 80px;
  }
}

.campaign_award_item {
  position: relative;
  z-index: 4;
  width: 33%;

  &::before {
    content: '';
    position: absolute;
    top: 1%;
    left: 0;
    right: 0;
    z-index: 1;
    width: 25%;
    margin: 0 auto;
    aspect-ratio: 5 / 9;
    transform-origin: bottom center;
    animation: sway 2s ease-in-out infinite alternate;
    background: transparent url(/img/items/me.png) center no-repeat;
    background-size: contain;
    translate: -16% 4%;;
  }

  @include smView {
    width: 80%;
  }
}

@keyframes sway {
  0% {
    transform: rotate(-25deg);
  }

  50% {
    transform: rotate(-10deg);
  }

  100% {
    transform: rotate(-37deg);
  }
}

.campaign_award_item_main{
  position: relative;
  z-index: 4;
}

.campaign_award_item_hukidashi {
  position: absolute;
  z-index: 5;
  top: 4vw;
  right: -4vw;
  width: 40%;
  height: auto;
}

// 固定アンケートスタートボタン
.fixed_start_button {
  position: fixed;
  bottom: 20px;
  left: 50%;
  translate: -50% 0;
  z-index: 1000;
  width: 100%;
  max-width: 600px;
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.3s 0.1s ease, transform 0.3s 0.1s ease;

  @include smView {
    max-width: 90%;
    bottom: 10px;
  }

  &.hidden {
    opacity: 0;
    translate: -50% 10px;
    pointer-events: none;
  }
}

.questionary_start_content {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

.questionary_start_character {
  position: absolute;
  z-index: 4;
  bottom: 50%;
  width: 35%;
  pointer-events: none;

  @include smView {
    width: 40%;
  }
}

.questionary_start_character > img {
  transform: translateY(20%);
}

.questionary_start_btn {
  position: relative;
  top: 45%;
  transition: top 0.4s ease, left 0.4s ease;
  z-index: 5;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;

  &:active {
    transform: none;
  }
}

.questionary_italic {
  font-style: italic;
}

// 固定ボタンのアニメーション

.movie_copy_wrap {
  margin-bottom: 30px;
}
.movie_copy {
  position: relative;
  width: fit-content;
  font-weight: 700;
  line-height: 1;
  font-size: 38px;
  margin: 0 auto;
  display: flex;
  gap: 0;

  @include mdView {
    font-size: 32px;
  }

  @include smView {
    font-size: 19px;
    flex-direction: column;
    align-items: center;
    gap: 5px 0;
  }
}

.movie_copy_span {
  display: inline-block;
  width: fit-content;
  background-color: white;
  padding: 10px;

  &:first-child {
    padding-right: 0;
  }

  &:last-child {
    padding-left: 0;
  }

  @include smView  {
    padding: 5px;
  }
}


</style>
